import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { CallAPIGetPromise, CallAPIPostPromise } from "Common/commaon";
import { Switch } from "./ui/switch";




export function AddAppDialog({ open, onOpenChange, onAdd }) {
  const [formData, setFormData] = useState({
    name: "",
    icon: "",
    iosVersion: "1.0.0",
    iosBuildNumber: "1",
    iosForceUpdate: false,
    androidVersion: "1.0.0",
    androidBuildNumber: "1",
    androidForceUpdate: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newApp = {
      id: Date.now().toString(),
      name: formData.name,
      app_name: formData.name,
      iosVersion: formData.iosVersion,
      ios_version: formData.iosVersion,
      iosBuildNumber: formData.iosBuildNumber,
      ios_build_number: formData.iosBuildNumber,
      iosStatus: "development",
      ios_status: "development",
      iosForceUpdate: formData.iosForceUpdate,
      ios_force_update: formData.iosForceUpdate,
      androidVersion: formData.androidVersion,
      android_version: formData.androidVersion,
      androidBuildNumber: formData.androidBuildNumber,
      android_build_number: formData.androidBuildNumber,
      androidStatus: "development",
      android_status: "development",
      androidForceUpdate: formData.androidForceUpdate,
      android_force_update: formData.androidForceUpdate,
      lastUpdated: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };
 CallAPIPostPromise("/admin/createApp",newApp).then((res)=>{
  console.log(res)
 })
    onAdd(newApp);
    setFormData({
      name: "",
      icon: "",
      iosVersion: "1.0.0",
      iosBuildNumber: "1",
      iosForceUpdate: false,
      androidVersion: "1.0.0",
      androidBuildNumber: "1",
      androidForceUpdate: false,
    });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] tailwind-prefix">
        <div>
          <DialogTitle>Add New App</DialogTitle>
          <DialogDescription>
            Create a new app to track versions across iOS and Android platforms.
          </DialogDescription>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="name">App Name</Label>
              <Input
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="My Awesome App"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="icon">Icon (emoji or single character)</Label>
              <Input
                id="icon"
                value={formData.icon}
                onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                placeholder="📱"
                maxLength={2}
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="iosVersion">iOS Version</Label>
                <Input
                  id="iosVersion"
                  value={formData.iosVersion}
                  onChange={(e) => setFormData({ ...formData, iosVersion: e.target.value })}
                  placeholder="1.0.0"
                  required
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="iosBuild">iOS Build</Label>
                <Input
                  id="iosBuild"
                  value={formData.iosBuildNumber}
                  onChange={(e) => setFormData({ ...formData, iosBuildNumber: e.target.value })}
                  placeholder="1"
                  required
                />
              </div>
            </div>

            <div className="flex items-center justify-between rounded-md border p-3">
              <div>
                <Label htmlFor="iosForceUpdate">iOS Force Update</Label>
                <p className="text-sm text-gray-500">Require iOS users to update when behind.</p>
              </div>
              <Switch
                id="iosForceUpdate"
                checked={formData.iosForceUpdate}
                onCheckedChange={(checked) => setFormData({ ...formData, iosForceUpdate: checked })}
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="androidVersion">Android Version</Label>
                <Input
                  id="androidVersion"
                  value={formData.androidVersion}
                  onChange={(e) => setFormData({ ...formData, androidVersion: e.target.value })}
                  placeholder="1.0.0"
                  required
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="androidBuild">Android Build</Label>
                <Input
                  id="androidBuild"
                  value={formData.androidBuildNumber}
                  onChange={(e) => setFormData({ ...formData, androidBuildNumber: e.target.value })}
                  placeholder="1"
                  required
                />
              </div>
            </div>

            <div className="flex items-center justify-between rounded-md border p-3">
              <div>
                <Label htmlFor="androidForceUpdate">Android Force Update</Label>
                <p className="text-sm text-gray-500">Require Android users to update when behind.</p>
              </div>
              <Switch
                id="androidForceUpdate"
                checked={formData.androidForceUpdate}
                onCheckedChange={(checked) => setFormData({ ...formData, androidForceUpdate: checked })}
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit">Add App</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
